import React from "react";
import useAppContext, { ACCOUNT_TYPES } from "state/AppContext";
import AdminCreateClientPage from "pages/ClientView/CreateClusterPage/AdminCreateClientPage";
import RecruiterCreateClientPage from "pages/RecruitersView/RecruiterCreateClientPage/RecruiterCreateClientPage";
import ErrorPage from "pages/ErrorPage/ErrorPage";

export default function CreateClientSwitch() {
  const appContext = useAppContext();
  const { account } = appContext;
  const { accountType } = account;

  if (accountType.type === ACCOUNT_TYPES.ADMIN.type) {
    return <AdminCreateClientPage />;
  } else if (accountType.type === ACCOUNT_TYPES.RECRUITER.type) {
    return <RecruiterCreateClientPage />;
  } else {
    return <ErrorPage />;
  }
}
